import React from "react";
// ...existing code... (removed unused Link import)

import { FormHandler } from "Components/Form";
import { RegistrationForm } from "Components/Partials";
import Authenticated from "Components/Layouts/Authenticated";

import MeApi from 'Services/Api/Me/Me';
import User from 'Services/User';
import ModalService from 'Services/Modal';
import Confirm from 'Components/Partials/Modals/Confirm';
import CancelAttendanceModal from 'Components/Partials/Modals/CancelAttendanceModal';
import { registeredStage as getRegisteredStage } from 'Services/AttendanceHelpers';
import { DateTime } from "luxon";
import { getTargetDateString } from 'Services/DateHelpers';
import { Container } from "Components/Utilities";
import { PrimaryButton } from "Components/Button";
import { asset } from "Services/BaseHelpers";

class Registration extends React.Component {
    constructor (props) {
        super(props);

        const user = User.loggedIn ? User.data : null;
        const registeredStage = getRegisteredStage(user);

        this.state = {
            stage: null,
            group: registeredStage ? user.first_group_name : null,
            afternoon_session_acknowledgement: registeredStage ? user.afternoon_session_acknowledgement : null,
            attendance_status: registeredStage ? user.attendance_status : null,
            pendingOffer: null,
            // Status the logged in delegate already holds, so a returning user sees their
            // confirmation instead of an empty registration form.
            registeredStage,
        };
    }

    async componentDidMount() {
        const response = await MeApi.getPendingAttendanceOffer();
        if (response?.status === 200) {
            this.setState({
                pendingOffer: response?.data?.offer ?? null,
            });
        }
    }

    handleSuccess = (attendanceStatus, attending, group, afternoon_session_acknowledgement) => {
        // Always trust the attendance status returned by the server — it is what reporting uses,
        // so the confirmation screen can never disagree with how the delegate is recorded.
        let stage;

        if (attendanceStatus === 'external_waitlist' || attendanceStatus === 'internal_waitlist') {
            stage = 'confirm-waitlist';
        } else if (attendanceStatus === 'confirmed_in_person') {
            stage = 'confirm-attending';
        } else if (attendanceStatus === 'virtual') {
            stage = 'confirm-not-attending';
        } else {
            stage = attending ? 'confirm-attending' : 'confirm-not-attending';
        }

        this.setState({
            stage,
            group: group,
            afternoon_session_acknowledgement: afternoon_session_acknowledgement,
            attendance_status: attendanceStatus,
        });
    };

    handleCancelInPerson = () => {
        ModalService.open({
            component: CancelAttendanceModal,
            props: {
                onCancelled: this.handleCancelled,
            },
        });
    };

    handleCancelled = (action, attendanceStatus) => {
        this.setState({
            stage: action === 'switch_to_virtual' ? 'confirm-not-attending' : 'confirm-cancelled',
            attendance_status: attendanceStatus,
        });
    };

    handleLeaveWaitlist = () => {
        ModalService.open({
            component: Confirm,
            props: {
                title: 'Leave the in-person waitlist?',
                message: 'You will keep your virtual place, and we will stop contacting you about in-person spaces.',
                cancelText: 'Stay on the waitlist',
                confirmText: 'Leave the waitlist',
                onConfirm: this.leaveWaitlist,
            },
        });
    };

    leaveWaitlist = async () => {
        const response = await MeApi.cancelAttendance({ action: 'switch_to_virtual' });
        if (response?.status === 200) {
            this.setState({
                stage: 'confirm-not-attending',
                attendance_status: response.data?.attendance_status,
            });
        }
    };

    handleOfferResponse = async (action) => {
        const { pendingOffer } = this.state;
        if (!pendingOffer?.id) {
            return;
        }

        const response = await MeApi.respondToAttendanceOffer({ action });
        if (response?.status === 200) {
            this.setState({
                pendingOffer: null,
                stage: action === 'accept' ? 'confirm-attending' : 'confirm-not-attending',
            });
        }
    };

    handleSubmit = (data) => MeApi.registration(data);

    render () {
        const { stage: submittedStage, registeredStage, group, afternoon_session_acknowledgement, pendingOffer } = this.state;

        // Anything the delegate has just done on this page wins. Otherwise fall back to the
        // status they already hold — unless there is an offer waiting, which has to be
        // answered before we show them where they currently stand.
        const stage = submittedStage ?? (pendingOffer ? null : registeredStage);

        const isPastDeadline = DateTime.now() > DateTime.fromISO('2026-10-03T00:01:00');

        // An admin signed in on the public page is registering someone else at the desk, so
        // they get the same confirmation screen as the admin area — without the cancel
        // button, which would act on the admin's own account rather than the delegate's.
        const isAdminView = Boolean(this.props.isAdmin) || (User.loggedIn && User.data?.is_admin === true);

    // if (stage === 'registration-closed' || isPastDeadline) {
    //     return (
    //         <Authenticated pageVideoHeader={ true }>
    //             <div className="py-10 lg:py-20">
    //                 <Container>
    //                     <div className="text-center text-app-blue space-y-6">
    //                         <h2 className="text-5xl font-bold mb-4">Registration Closed</h2>
    //                         <p>Registration for the Bupa Symposium has closed.</p>
    //                         <p>
    //                             If you have any questions, please contact us at <a href="mailto:reply@bupahealthcaresymposium.com" className="underline">healthcaresymposium@bupa.com</a>
    //                         </p>
    //                     </div>
    //                 </Container>
    //             </div>
    //         </Authenticated>
    //     );
    // }

        if (stage === 'confirm-attending' && !isAdminView) {
            return (
                <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                    <div className="py-10 lg:py-20">
                        <Container>
                            <div className="text-center text-app-blue space-y-6">
                                <h2 className="text-3xl font-bold">Your place is reserved!</h2>
                                <p className="text-lg">We look forward to welcoming you to Bupa Symposium 2026.</p>
                                <div className="text-2xl font-semibold">{ getTargetDateString(true) }</div>
                                <p>Click the button below to download the invitation to your calendar.</p>
                                <div>
                                    { group?.includes('virtual') ? (
                                        <a href={ asset('images/bupa-virtual.ics') } download="bupa-virtual.ics">
                                            <PrimaryButton text="Add to calendar" />
                                        </a>
                                    ) : (
                                        <a href={ asset(afternoon_session_acknowledgement ? 'images/bupa-afternoon-26.ics' : 'images/bupa-26.ics') } download={afternoon_session_acknowledgement ? 'bupa-afternoon-26.ics' : 'bupa-26.ics'}>
                                            <PrimaryButton text="Add to calendar" />
                                        </a>
                                    ) }
                                </div>
                                <p className="mt-4">Watch out for more updates from us soon.</p>
                                <div>
                                    <PrimaryButton text="Cancel In-Person Attendance" onClick={this.handleCancelInPerson} />
                                </div>
                                <p>If you have any questions please contact <a href="mailto:healthcaresymposium@bupa.com" className="underline">healthcaresymposium@bupa.com</a></p>
                            </div>
                        </Container>
                    </div>
                </Authenticated>
            );
        } else if (stage === 'confirm-attending' && isAdminView) {
            return (
                <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                    <div className="py-10 lg:py-20">
                        <Container>
                            <div className="text-center text-app-blue space-y-6">
                                <h2 className="text-3xl font-bold">Your place is reserved!</h2>
                                <p className="text-lg">We look forward to welcoming you to Bupa Symposium 2026.</p>
                                <div className="text-2xl font-semibold">{ getTargetDateString(true) }</div>
                                <p>Click the button below to download the invitation to your calendar.</p>
                                <div>
                                    { group?.includes('virtual') ? (
                                        <a href={ asset('images/bupa-virtual.ics') } download="bupa-virtual.ics">
                                            <PrimaryButton text="Add to calendar" />
                                        </a>
                                    ) : (
                                        <a href={ asset(afternoon_session_acknowledgement ? 'images/bupa-afternoon-26.ics' : 'images/bupa-26.ics') } download={afternoon_session_acknowledgement ? 'bupa-afternoon-26.ics' : 'bupa-26.ics'}>
                                            <PrimaryButton text="Add to calendar" />
                                        </a>
                                    ) }
                                </div>
                                <p className="mt-4">Watch out for more updates from us soon.</p>
                                <p>If you have any questions please contact <a href="mailto:healthcaresymposium@bupa.com" className="underline">healthcaresymposium@bupa.com</a></p>
                            </div>
                        </Container>
                    </div>
                </Authenticated>
            );
        }

        if (stage === 'confirm-waitlist') {
            return (
                <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                    <div className="py-10 lg:py-20">
                        <Container>
                            <div className="text-center text-app-blue space-y-6">
                                <h2 className="text-3xl font-bold">You're on the waitlist!</h2>
                                <p className="text-lg">In-person capacity is full, so we have added you to the waitlist. We will notify you if a space becomes available.</p>
                                <div className="text-2xl font-semibold">{ getTargetDateString(true) }</div>
                                <p>In the meantime, you can still join us virtually. Click the button below to download the virtual invitation to your calendar.</p>
                                <div>
                                    <a href={ asset('images/bupa-virtual.ics') } download="bupa-virtual.ics">
                                        <PrimaryButton text="Add to calendar" />
                                    </a>
                                </div>
                                <p className="mt-4">Watch out for more updates from us soon.</p>
                                <div>
                                    <PrimaryButton text="Leave the waitlist" onClick={this.handleLeaveWaitlist} />
                                </div>
                                <p>If you have any questions please contact <a href="mailto:healthcaresymposium@bupa.com" className="underline">healthcaresymposium@bupa.com</a></p>
                            </div>
                        </Container>
                    </div>
                </Authenticated>
            );
        }

        if (stage === 'confirm-cancelled') {
            return (
                <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                    <div className="py-10 lg:py-20">
                        <Container>
                            <div className="text-center text-app-blue space-y-6">
                                <h2 className="text-3xl font-bold">Your in-person attendance has been cancelled</h2>
                                <p>No further event communications will be sent.</p>
                            </div>
                        </Container>
                    </div>
                </Authenticated>
            );
        }

        if ( stage === 'confirm-not-attending' ) {
            return (
                <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                    <div className="py-10 lg:py-20">
                        <Container>
                            <div className="text-center text-app-blue space-y-6">
                                <h2 className="text-3xl font-bold">Your <strong>virtual</strong> place is reserved!</h2>
                                <p className="text-lg">We look forward to welcoming you to Bupa Symposium 2026.</p>
                                <div className="text-2xl font-semibold">{ getTargetDateString(true) }</div>
                                <p>Click the button below to download the virtual invitation to your calendar.</p>
                                <div>
                                    { /* This screen is only ever reached by virtual delegates, so the
                                         in-person venue invite must never be offered here. */ }
                                    <a href={ asset('images/bupa-virtual.ics') } download="bupa-virtual.ics">
                                        <PrimaryButton text="Add to calendar" />
                                    </a>
                                </div>
                                <p className="mt-4">Watch out for more updates from us soon.</p>
                                <p>If you have any questions please contact <a href="mailto:healthcaresymposium@bupa.com" className="underline">healthcaresymposium@bupa.com</a></p>
                            </div>
                        </Container>
                    </div>
                </Authenticated>
            );
        }

        if (pendingOffer && !stage) {
            return (
                <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                    <div className="py-10 lg:py-20">
                        <Container>
                            <div className="text-center text-app-blue space-y-6">
                                <h2 className="text-3xl font-bold">An in-person seat is available for you</h2>
                                <p>Please accept or decline your waitlist offer before it expires.</p>
                                <div className="flex justify-center gap-4">
                                    <PrimaryButton text="Accept In-Person" onClick={() => this.handleOfferResponse('accept')} />
                                    <PrimaryButton text="Decline" onClick={() => this.handleOfferResponse('decline')} />
                                </div>
                            </div>
                        </Container>
                    </div>
                </Authenticated>
            );
        }

        if(this.props.isAdmin) {
            return (
                <RegistrationForm
                    onSubmit={ this.handleSubmit }
                    onSuccess={ this.handleSuccess }
                    isAdmin={ true }
                    { ...this.props }
                />
            );
        }

        return (
            <Authenticated pageVideoHeader={ "bupa-banner.mp4" }>
                <RegistrationForm
                    onSubmit={ this.handleSubmit }
                    onSuccess={ this.handleSuccess }
                    { ...this.props }
                    isAdmin={ false }
                    disableInPerson={isPastDeadline}
                    isPastDeadline={isPastDeadline}
                />
            </Authenticated>
        );
    }
}

export default FormHandler ( Registration );
